(function () {
    'use strict';

    var app = angular.module('AladdinCommercial', ['ui.router', 'ngAnimate', 'LocalStorageModule']);

    app.config(["$locationProvider", function ($locationProvider) {
        // use the HTML5 History API
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false,
            rewriteLinks: false
        });
    }]);

    app.config(["localStorageServiceProvider", function (localStorageServiceProvider) {
        localStorageServiceProvider.setPrefix("AladdinCommercial");
    }]);

    app.config(['$httpProvider', function ($httpProvider) {
        if (!$httpProvider.defaults.headers.get) {
            $httpProvider.defaults.headers.get = {};
        }

        $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
        $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
        $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
    }]);

    app.constant('RetailerConstants', {
        zipcodeRegex: /^(\d{5}-\d{4})|(\d{5})|([AaBbCcEeGgHhJjKkLlMmNnPpRrSsTtVvXxYy]\d[A-Za-z]\s?\d[A-Za-z]\d)$/
    });

    // http://stackoverflow.com/a/25513186/1325534
    app.filter('trust', ['$sce', function ($sce) {
        return function (htmlCode) {
            return $sce.trustAsHtml(htmlCode);
        };
    }]);

    app.constant('AccountSettings', {
        baseUrl: '/mvc/api/FlooringAccount',
        authStorageKey: 'authData',
        clientName: 'Mohawk Flooring Website'
    });

    app.constant('CartSettings', {
        baseUrl: '/api/cart',
        displaySampleAddedCaller: 'displaySampleAddedCaller'
    });
    
    app.constant('ProductSettings', {
        productsApiUrl : '/api/products'
    });

    app.constant('SiteFeatures', {
        touch: ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch
    });

    app.constant('APP_EVENTS', {
        // product finder events
        'NEXT_FINDER_VIEW': 'next-finder-view',
        'PREV_FINDER_VIEW': 'prev-finder-view'
    });

    app.constant('APP_EVENTS', {
        resizeMap: 'resizeMap',
        productComparisonClearAll: 'productComparisonClearAll'
    });

    app.constant('FILTER_SORT', {
        "fiber brand": ["smartstrand", "smartstrand silk", "smartstrand silk reserve", "air.o", "wear-dated", "everstrand", "permastrand"],
        "shade": ["light", "medium", "dark"]
    });
})();
/*global angular */
(function () {
    'use strict';

    angular.module('AladdinCommercial').controller('BaseController', ['$scope', function($scope) {

        // https://coderwall.com/p/ngisma/safe-apply-in-angular-js
        $scope.safeApply = function(fn) {
            var phase = this.$root.$$phase;
            if (phase === '$apply' || phase === '$digest') {
                if (fn && (typeof(fn) === 'function')) {
                    fn();
                }
            } else {
                this.$apply(fn);
            }
        };

    }]);
})();
/*global angular, _, $ */
(function () {
    'use strict';

    angular.module('AladdinCommercial').controller('PdpController', ['$controller', '$scope',  '$window', '$location', 'SearchService', function ($controller, $scope, $window, $location, SearchService) {

        $controller('BaseController', {
            $scope: $scope
        });

        function selectColorSuccess(result) {
            assignScope(result.data);
            $location.path(result.data.pdpUrl);
            $location.replace();
        }

        $scope.selectColor = function (styleId, colorId) {
            SearchService.loadProductDetail(styleId, colorId, selectColorSuccess, handleError);
        };
        
        function initSuccess(result) {
            assignScope(result);
            assignAllColors(result);
        }

        $scope.init = function (styleId, colorId) {
            if ($window.pdpInitData === undefined && $window.specifications !== undefined){
                SearchService.loadProductDetail(styleId, colorId, initSuccess, handleError);
            }
            else 
            {
                assignScope($window.pdpInitData);
                assignAllColors($window.pdpInitData);
            }

        };

        function handleError(data) {
            console.error(data);
        }

        function assignScope(data)
        {
            $scope.isStyleDiscontinued = data.style.isDeleted;
            $scope.style = data.style;
            $scope.mainColor = data.mainColor;
            $scope.hasSamples = data.style.selectedColor.specifications == "True" ;
            $scope.isStyleDiscontinued = data.style.isDeleted;
            $scope.isColorDiscontinued = data.mainColor.isDeleted;
            $scope.pdpUrl = data.pdpUrl;
            $scope.swatchPath = data.swatchPath;
            $scope.retailerZip = data.retailerZip;
            $scope.retailerZip = data.retailerZip;
            $scope.printUrl = data.printUrl;
            $scope.roomSceneImageUrl = data.roomSceneImageUrl;
            $scope.hasRoomScene = !!$scope.roomSceneImageUrl;
            $scope.centerClass = $scope.hasRoomScene ? "" : "center";
            $scope.productFamilyDescription = data.productFamilyDescription;
            $scope.sellSheetPdfUrl = data.sellSheetPdfUrl;
            $scope.hasSellSheetPdfUrl = !!data.sellSheetPdfUrl;
            $scope.ltEleven = data.allColors.length < 11 ? "ltEleven" : "";
            $scope.lteFive = data.allColors.length <= 5 ? "lteFive" : "";
            $scope.lteFour = data.allColors.length <= 4 ? "lteFour" : "";
            $scope.centerCarousel = $scope.ltEleven ? "center" : "";
            $scope.specSheetPdfUrl = data.productSpecsPdfUrl;
            $scope.hasSpecSheet = !!data.productSpecsPdfUrl;
            $scope.specGroup1 = data.specGroup1;
            $scope.specGroup2 = data.specGroup2;
            $scope.quickShip = data.quickShip;
            $scope.quickShipNum = data.quickShipNum;
        }
        
        function assignAllColors(data)
        {
            $scope.allColors = data.allColors;
            $scope.allColorsText = data.allColorsText;
        }

    }]);
})();
/*global angular, _, $ */
(function () {
    'use strict';

    angular.module('AladdinCommercial').controller('PlpController', ['$controller', '$scope', '$location', '$window', '$timeout', 'SearchService', 'CompareService', 'APP_EVENTS', 'FILTER_SORT', 'localStorageService', '$interval', function ($controller, $scope, $location, $window, $timeout, SearchService, CompareService, APP_EVENTS, FILTER_SORT, localStorageService, $interval) {

        $controller('BaseController', {
            $scope: $scope
        });

        $scope.family = '';
        $scope.query = $location.search().q || '';
        $scope.showAll = $location.search().show === 'all';
        $scope.lastSearched = $scope.query;
        $scope.facetGroups = [];
        $scope.selectedFacets = {};
        $scope.defaultPageSize = 24;
        $scope.currentTab = $location.search().tab;
        $scope.isLoading = false;
        $scope.isLoadingCompare = false;
        $scope.objSorting = { sorting: '' };
        $scope.hasError = false;
        $scope.forceColorIndex = $location.search().colorIndex === "1";
        $scope.rangeMin = 1;
        $scope.rangeMax = 0;

        //Product Comparison
        var compareDescription = 'Compare up to 3 products.';
        var compareOverflowDescription = 'A maximum of 3 products can be compared at one time.';
        var compareFamilyUnmatchDescription = 'Products with different product family cannot be compared.';
        var comparePageUrl = '/compare-products';
        var COMPARISON_MAX_NUM = 3;
        var firstRequest = true;
        $scope.productsToCompare = [];
        $scope.productsToCompareResults = [];
        $scope.showViewAllButton = false;
        $scope.comparePrintLink = "";
        $scope.compareActiveDescription = compareDescription;
        $scope.showCompareWarning = false;
        $scope.familyCompared = "";
        $scope.initialLoadStoredProducts = true;

        //Search
        var productTypeKey = 'productType';
        var subFamilyKey = 'subFamily';
        $scope.selectedProductTypeName = null;
        $scope.selectedSubFamily = null;
        $scope.searchProductTypes = [{
                name: 'All Products',
                value: 'allProducts',
                key: productTypeKey
            },
            {
                name: 'Carpet',
                value: 'Carpet',
                key: productTypeKey
            },
            {
                name: 'Hard Surface',
                value: 'HardSurface',
                key: productTypeKey
            }
        ];

        $scope.tryAddToCompare = function(style) {
            var isAdded = true;
            var index = _.findIndex($scope.productsToCompare, function (e) { return e.styleId === style.styleId; });

            if ($scope.productsToCompare.length === 0) {
                $scope.familyCompared = style.family;
            }

            if (index > -1) {
                $scope.productsToCompare.splice(index, 1);
                CompareService.removeFromLocalStorage(style.styleId);
                $scope.changeCompareDescription(false);
                isAdded = false;
            } else if ($scope.productsToCompare.length < COMPARISON_MAX_NUM && $scope.familyCompared == style.family) {
                $scope.productsToCompare.push(style);
                $scope.changeCompareDescription(false);
            } else if ($scope.familyCompared != style.family) {
                isAdded = false;
                $scope.changeCompareDescriptionFamily();
            } else {
                isAdded = false;
                $scope.changeCompareDescription(true);
            }
            $scope.safeApply();
            return isAdded;
        };

        $scope.changeCompareDescription = function (overflow) {
            if (overflow) {
                $scope.compareActiveDescription = compareOverflowDescription;
                $scope.showCompareWarning = true;
            } else {
                $scope.compareActiveDescription = compareDescription;
                $scope.showCompareWarning = false;
            }
        };

        $scope.changeCompareDescriptionFamily = function() {
            $scope.compareActiveDescription = compareFamilyUnmatchDescription;
            $scope.showCompareWarning = true;
        };

        function resetResults() {
            $scope.styles.length = 0;
            $scope.totalResults = -1;
            $scope.currentPage = 0;
            $scope.rangeMin = 1;
            $scope.rangeMax = 0;
            $scope.hasMore = false;
        }


        function stylesFailed(data) {
            $scope.isLoading = false;
            $scope.errorMessage = (data && data.data && data.data.Message) || "Unexpected error";
            $scope.errorMessage = $scope.errorMessage.toLowerCase();
            $scope.hasError = true;

            // Regenerate the dropdown panels that are added client side
            $timeout(InitializeDropdowns, 1000);
        }

        function stylesUpdated(newStyles, totalResults) {
            $scope.errorMessage = null;
            $scope.totalResults = totalResults;
            $scope.totalPages = Math.floor($scope.totalResults / $scope.defaultPageSize) + 1;
            $scope.rangeMax += newStyles.length;
            $scope.hasMore = $scope.rangeMax < totalResults;
            var storedCompareProducts = localStorageService.get(CompareService.getLocalStorageKey());

            if ($scope.initialLoadStoredProducts) {
                if (storedCompareProducts && storedCompareProducts.length > 0) {
                    $scope.productsToCompare = storedCompareProducts;
                    $scope.familyCompared = $scope.productsToCompare[0].family;
                }
            }

            _.forEach(newStyles, function(style) {
                if ($scope.productsToCompare && $scope.productsToCompare.filter(checkMatchingStyle(style)).length > 0) {
                    style.compareChecked = true;
                }
                $scope.styles.push(style);
            });

            $scope.initialLoadStoredProducts = false;

            var currentPage = $location.search().page;
            if (currentPage > 1 && $window.sessionStorage.getItem('shouldScroll') == 1) {
                var waitTime = currentPage * 150;
                $timeout(function () {
                    $window.scrollTo(0, $window.sessionStorage.getItem('plpScroll'));
                    $window.sessionStorage.setItem('shouldScroll', angular.toJson(0));
                }, waitTime);
            }

            // hotjar heatmap trigger
            var event = $scope.family ? 'plp_' + $scope.family + '_heatmap' : 'plp_allproducts_heatmap';
            HotjarTriggers.triggerDelayed(event, 1000);

            // Regenerate the dropdown panels that are added client side
            $timeout(InitializeDropdowns, 1000);

            $scope.isLoading = false;
            $scope.hasError = false;
        }

        function checkMatchingStyle(style) {
            return function(product) {
                return product.styleId == style.styleId;
            };
        }

        function InitializeDropdowns() {
            _.forEach($('.dropdown-pane'), function (dropdown) {
                if (!$(dropdown).attr('data-yeti-box')) {
                    $(dropdown).foundation();
                }
            });
        }

        function loadStyles() {
            $scope.isLoading = true;

            if (!firstRequest) {
                if ($scope.currentPage >= $scope.totalPages) {
                    $scope.isLoading = false;
                    return;
                }
                $scope.currentPage++;
                if ($scope.currentPage > 1) {
                    $location.search('page', $scope.currentPage);
                }
            }

            var size = $scope.defaultPageSize;
            var page = $scope.currentPage;
            if (firstRequest) {
                size = page * $scope.defaultPageSize;
                page = 0;

                if ($scope.currentPage > 1) {
                    $location.search('page', $scope.currentPage);
                }
            } else {
                page--;
            }

            var subFamily = $scope.selectedSubFamily ? $scope.selectedSubFamily.value : null;

            SearchService.loadStyles($scope.family, page, size, $scope.selectedFacets, $scope.objSorting.sorting, $scope.query, subFamily, $scope.forceColorIndex);
            $scope.lastSearched = $scope.query;
            firstRequest = false;
        }

        var facetHelper = {
            checkFacet: function (facetGroups, facetKey, facetValues) {
                _.forEach(facetGroups, function (facetGroup) {
                    _.forEach(facetGroup.values, function (facet) {
                        if (facet.key.toLowerCase() === facetKey.toLowerCase()) {
                            if (facetValues === 'True') {
                                facet.checked = true;
                            } else {
                                facet.checked = (facetValues.constructor === Array) ? facetValues.indexOf(facet.value) > -1 : facet.value === facetValues;
                            }
                        }
                    });
                });
            },

            uncheckFacet: function (facetGroups, facetKey) {
                _.forEach(facetGroups, function (facetGroup) {
                    _.forEach(facetGroup.values, function (facet) {
                        if (facet.key === facetKey) {
                            facet.checked = false;
                        }
                    });
                });
            },

            selectFacet: function (selectedFacets, facetKey, facetValues) {
                var selectedFacet = selectedFacets[facetKey];
                if (selectedFacet) {
                    selectedFacet.push(facetValues);
                } else if (facetValues.constructor === Array) {
                    selectedFacets[facetKey] = facetValues.slice(0);
                } else {
                    selectedFacets[facetKey] = [facetValues];
                }
            },
            reorderFacetValues: function (facetValues, orderList) {
                if (!facetValues || !orderList) {
                    return;
                }
                facetValues.sort(function (x, y) {
                    return orderList.indexOf(x.value.toLowerCase()) < orderList.indexOf(y.value.toLowerCase()) ? -1 : 1;
                });
            },
            toggleFacetSelection: function (selectedFacets, key, value) {
                var selectedFacet = selectedFacets[key];
                if (selectedFacet) {
                    var index = selectedFacet.indexOf(value);
                    if (index < 0) {
                        selectedFacet.push(value);
                    } else if (selectedFacet.length > 1) {
                        selectedFacet.splice(index, 1);
                    } else {
                        // Last item; delete the entry to avoid an empty array
                        delete selectedFacets[key];
                    }
                } else {
                    selectedFacets[key] = [value];
                }
            },
            removeFacetSelection: function(selectedFacets, key) {
                delete selectedFacets[key];
            },
            toggleSearchValue: function (key, value) {
                var entry = $location.search()[key];
                if (!entry) {
                    entry = [];
                } else if (entry.constructor !== Array) {
                    entry = [entry];
                }
                var index = entry.indexOf(value);
                if (index < 0) {
                    entry.push(value);
                } else if (entry.length > 1) {
                    entry.splice(index, 1);
                } else {
                    entry = null;
                }
                $location.search(key, entry).replace();
            },
            removeSearchValue: function (key, value) {
                var entry = $location.search()[key];
                if (entry) {
                    if (entry.constructor !== Array) {
                        entry = [entry];
                    }
                    var index = entry.indexOf(value);
                    if (index > -1) {
                        entry.splice(index, 1);
                    }
                    $location.search(key, entry).replace();
                }
            },
            removeSearchKey: function (key) {
                var entry = $location.search()[key];
                if (entry) {
                    entry = null;
                    $location.search(key, entry).replace();
                }
            },
            isFacetKey: function (facetKey) {
                var key = facetKey.toLowerCase();
                return key !== 'sort' && key !== 'q' && key !== 'page' && key !== 'producttype' && key !== 'subfamily' && key !== 'colorindex';
            }
        };

        function facetsUpdated(facetGroups) {
            facetHelper.removeSearchValue('colors.specifications.Samples', 'false');

            _.forEach(facetGroups, function (facetGroup) {
                facetHelper.reorderFacetValues(facetGroup.values, FILTER_SORT[facetGroup.text.toLowerCase()]);
                $scope.facetGroups.push(facetGroup);
            });

            _.forEach($location.search(), function (searchVal, searchKey) {
                if (facetHelper.isFacetKey(searchKey)) {
                    facetHelper.checkFacet($scope.facetGroups, searchKey, searchVal);
                    facetHelper.selectFacet($scope.selectedFacets, searchKey, searchVal);
                }
                else if (searchKey.toLowerCase() === 'subfamily') {
                    var subFamilies = _.find(facetGroups, function(facetGroup) { return _.find(facetGroup.values, {'key': subFamilyKey}); });
                    var subFamily = _.find(subFamilies.values, {'value': searchVal});
                    $scope.selectedSubFamily = subFamily;
                }
            });

            loadStyles();
        }

        function loadFacets() {
            SearchService.loadFacets($scope.family);
        }

        $scope.init = function (family) {
            $scope.styles = [];
            $scope.family = family;
            $scope.showQuery = !!$scope.query || (!$scope.family && !$scope.showAll);
            $scope.isSearch = !$scope.family;
            $scope.objSorting.sorting = $scope.isSearch ? 'relevance' : 'A-Z';

            initSearchMode();

            SearchService.subscribeStyles(stylesUpdated, stylesFailed);
            SearchService.subscribeFacets(facetsUpdated);
            CompareService.subscribeStyles(compareStylesUpdated);

            var currentPage = $location.search().page;
            $scope.currentPage = currentPage ? parseInt(currentPage, 10) : 1;

            if ($scope.family) {
                loadFacets();
            } else {
                loadStyles();
            }

            $scope.$on(APP_EVENTS.productComparisonClearAll, function () {
                $scope.styles.forEach(function (style) {
                    if (style.compareChecked === true) {
                        style.compareChecked = false;
                    }
                });
            });
        };

        var initSearchMode = function () {
            $scope.searchMode = !$scope.family;

            var productType = $location.search()[productTypeKey];
            if (productType) {
                $scope.family = productType;
                $scope.selectedProductTypeName = _.find($scope.searchProductTypes, ['value', productType]).name;
            }
        };

        $scope.loadMore = loadStyles;

        $scope.toggleFacets = function (event) {
            var elementClicked = $(event.target).parents('div.filter');

            if (!(elementClicked.hasClass('active'))) {
                elementClicked.addClass('active');
            } else {
                elementClicked.removeClass('active');
            }
        };

        $scope.toggleFilterController = function (event) {
            var filterController = $(event.target);
            var filters = filterController.parents('.filters-wrapper').find('.filters');

            if (!filterController.hasClass('active')) {
                filterController.addClass('active');
                filters.removeClass('close');
            } else {
                filters.addClass('close');
                filterController.removeClass('active');
            }
        };

        $scope.changeSorting = function() {
            resetResults();
            loadStyles();
            $location.search('sort', $scope.objSorting.sorting);
        };

        $scope.styleAbsoluteUrl = function (styleUrl) {
            if (styleUrl) {
                return $location.host() + styleUrl;
            }
            return $location.absUrl();
        };

        $scope.hasSelectedFacets = function () {
            // If Object.keys() doesn't exist in a browser, we can use the following:
            // for (var facet in $scope.selectedFacets) if ($scope.selectedFacets.hasOwnProperty(facet)) return true;
            // return false;
            return Object.keys($scope.selectedFacets).length > 0;
        };

        $scope.facetClick = function (key, value) {
            facetHelper.toggleFacetSelection($scope.selectedFacets, key, value);
            facetHelper.toggleSearchValue(key, value);
            resetResults();
            loadStyles();
        };

        $scope.setProductType = function (value, name) {
            if (value !== 'allProducts') {
                if (value !== $scope.family) {
                    $scope.family = value;
                    $scope.selectedProductTypeName = name;

                    $location.search(productTypeKey, value);

                    $scope.facetGroups = [];
                    $scope.clearFilters();
                    resetResults();
                    loadFacets();
                }
            } else {
                $scope.family = $scope.selectedProductTypeName = null;

                facetHelper.removeSearchKey(productTypeKey);

                $scope.facetGroups = [];
                $scope.clearFilters();
                resetResults();
                loadStyles();
            }
        };

        $scope.setSubFamily = function(facet) {
            if (facet.value !== '') {
                $scope.selectedSubFamily = facet;

                $location.search(subFamilyKey, facet.value);

                resetResults();
                loadStyles();
            } else {
                facetHelper.removeSearchKey(subFamilyKey);

                $scope.selectedSubFamily = null;

                resetResults();
                loadStyles();
            }
        };

        $scope.clearFilters = function () {

            if (!$scope.hasSelectedFacets() && $scope.selectedSubFamily === null) {
                return;
            }

            var search = $location.search();
            for (var facetKey in $scope.selectedFacets) {
                facetHelper.uncheckFacet($scope.facetGroups, facetKey);
                delete search[facetKey];
            }
            $scope.selectedFacets = {};
            $location.search(search).replace();

            $scope.setSubFamily('');

            resetResults();
            loadStyles();
        };

        $scope.isSamplesFacet = function (facetGroup) {
            return facetGroup.text === 'Samples Available';
        };
        $scope.filterTrueValue = function (arr) {
            return arr ? arr.filter(function (i) {
                return i.value === 'true';
            }) : arr;
        };

        $scope.submit = function () {
            resetResults();
            loadStyles();

            $location.search('q', $scope.query ? $scope.query : null);
        };

        $scope.shouldHaveResults = function () {
            return $scope.lastSearched || $scope.family || $scope.showAll;
        };
        $scope.hasResults = function () {
            return $scope.totalResults > 0;
        };
        $scope.searchFinished = function () {
            return $scope.totalResults > -1;
        };
        $scope.canShowMore = function () {
            return $scope.totalResults >= 0 && $scope.hasMore === true;
        };
        $scope.showComparisonPopup = function () {
            return $scope.productsToCompare.length > 0;
        };
        $scope.enableCompareButton = function () {
            return $scope.productsToCompare.length > 1;
        };
        $scope.clearSelections = function () {
            $scope.productsToCompare = [];
            localStorageService.set(CompareService.getLocalStorageKey(), []);
            $scope.$broadcast(APP_EVENTS.productComparisonClearAll);
            $scope.safeApply();
        };

        $scope.compareProducts = function () {
            var productIds = [];
            angular.forEach($scope.productsToCompare, function(style, index) {
                productIds.push(style.styleId);
            });
            $window.location.href = comparePageUrl + '?pids=' + productIds.join(',');
        };

        function compareStylesUpdated(styles) {
            $scope.isLoadingCompare = false;
            $scope.productsToCompareResults = styles;
            $scope.showViewAllButton = $scope.productsToCompareResults.some(function (product) {
                return product.colors.length > 12;
            });
            $scope.updatePrintLink();
        }

        $scope.capitalizeFirstLetter = function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        };

        $scope.getRatingPartial = function (rating, index) {
            if (rating === 0) return 0;
            if (rating >= (index + 1)) return 1;
            if (rating < (index + 1) && rating > index) return (rating - index);
        };

        $scope.updatePrintLink = function () {
            $scope.productsToCompareResults.forEach(function (style, index, array) {
                $scope.comparePrintLink += "p" + (index + 1) + "=";
                $scope.comparePrintLink += encodeURIComponent(style.pdpUrl);
                if (index < array.length - 1) {
                    $scope.comparePrintLink += "&";
                }
            });
        };

        $scope.productClick = function () {
            $window.sessionStorage.setItem('plpScroll', angular.toJson($window.pageYOffset));
            $window.sessionStorage.setItem('shouldScroll', angular.toJson(1));
        };

        $scope.search = function() {
            $scope.changeQuery(searchInputForm.q.value);
        };

        $scope.facetSearch = function () {
            var term = $('#autoCompleteSearchBox').val();
            $scope.changeQuery(term);
        };

        $scope.changeQuery = function (query) {
            resetResults();
            $location.search('q', query ? query : null);
            $scope.query = $location.search().q || '';

            var stop = $interval(function() {
                if($('.product-wrapper .products li').length === 0){
                    loadStyles();
                    $interval.cancel(stop);
                }
            }, 100);
        };

        $scope.clearQuery = function () {
            if ($scope.query !== '') {
                $scope.changeQuery(null);
            }
        };

        $scope.predictiveSearchCollectionFacet = function (value) {
            var facet = 'collection.name.keyword';

            facetHelper.removeSearchKey(facet);
            facetHelper.removeFacetSelection(facet);

            facetHelper.toggleFacetSelection($scope.selectedFacets, facet, value);
            facetHelper.toggleSearchValue(facet, value);

            resetResults();
            loadStyles();
        };
    }]);
})();
(function () {
    angular.module('AladdinCommercial').directive('autoComplete', [function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {

                var styles = new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('normalizedStyleName', 'styleName', 'styleNumber', 'collection'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    prefetch: {
                        url: '/api/products/suggestStyles',
                        cache: true,
                        cacheKey: 'ac-suggest-styles'
                    },
                    sorter: function (current, next) {
                        var input_string = $('.tt-input').val().trim().toLowerCase();
                        var currentStyle = [current.styleName.toLowerCase(), current.styleNumber.toLowerCase()];
                        var nextStyle = [next.styleName.toLowerCase(), next.styleNumber.toLowerCase()];

                        if (currentStyle.indexOf(input_string) !== -1) {
                            return -1;
                        }

                        if (nextStyle.indexOf(input_string) !== -1) {
                            return 1;
                        }

                        if (_.find(currentStyle, function (s) { return s.indexOf(input_string) >= 0})) {
                            return -1;
                        }

                        if (_.find(nextStyle, function (s) { return s.indexOf(input_string) >= 0})) {
                            return 1;
                        }

                        return 0;
                    }
                });

                var colors = new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('normalizedColorName', 'colorName', 'colorNumber', 'normalizedStyleName', 'styleNumber'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    prefetch: {
                        url: '/api/products/suggestcolors',
                        cache: true,
                        cacheKey: 'ac-suggest-colors'
                    },
                    sorter: function (current, next) {
                        var input_string = $('.tt-input').val().trim().toLowerCase();
                        var currentColor = [current.colorName.toLowerCase(), current.colorNumber.toLowerCase()];
                        var nextColor = [next.colorName.toLowerCase(), next.colorNumber.toLowerCase()];

                        if (currentColor.indexOf(input_string) !== -1) {
                            return -1;
                        }

                        if (nextColor.indexOf(input_string) !== -1) {
                            return 1;
                        }

                        if (_.find(currentColor, function (s) { return s.indexOf(input_string) >= 0})) {
                            return -1;
                        }

                        
                        if (_.find(nextColor, function (s) { return s.indexOf(input_string) >= 0})) {
                            return 1;
                        }

                        return 0;
                    }
                });

                var collections = new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('normalizedCollection', 'collection'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    prefetch: {
                        url: '/api/products/suggestcollections',
                        cache: true,
                        cacheKey: 'ac-suggest-collections'
                    },
                    sorter: function (current, next) {
                        var input_string = $('.tt-input').val().trim().toLowerCase();
                        var currentCollection = current.collection.toLowerCase();
                        var nextCollection = next.collection.toLowerCase();

                        if (currentCollection === input_string) {
                            return -1;
                        }

                        if (nextCollection === input_string) {
                            return 1;
                        }

                        if (currentCollection.indexOf(input_string) !== -1) {
                            return -1;
                        }

                        if (nextCollection.indexOf(input_string) !== -1) {
                            return 1;
                        }

                        return 0;
                    }
                });

                var links = new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title', 'tags'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    prefetch: {
                        url: '/api/products/suggestlinks',
                        cache: true,
                        cacheKey: 'ac-suggest-links'
                    }
                });

                element.typeahead({
                    highlight: true,
                    hint: false
                },
                {
                    name: 'links',
                    display: 'title',
                    source: links,
                    limit: 2,
                    templates: {
                        suggestion: function (link) {
                            return '<div><a href="' + link.url + '" class="global-link">View All ' + link.title + ' Products</a></div>';
                        },
                        notFound: ''
                    }
                },
                {
                    name: 'styles',
                    display: 'label',
                    source: styles,
                    limit: 3,
                    templates: {
                        header: '<h5>Styles</h5>',
                        suggestion: function (style) {
                            return '<div><a href="' + style.path + '">' + style.label + '</a></div>';
                        },
                        footer: function (data) {
                            return '<div class="tt-footer"><a href="/search?q=' + data.query + '">View All Style Results for ' + data.query + '</a></div>';
                        },
                        notFound: ''
                    }
                },
                {
                    name: 'colors',
                    display: 'label',
                    source: colors,
                    limit: 3,
                    templates: {
                        header: '<h5>Colors</h5>',
                        suggestion: function (color) {
                            return '<div><a href="' + color.path + '">' + color.label + '</a></div>';
                        },
                        footer: function (data) {
                            return '<div class="tt-footer"><a href="/search?q=' + data.query + '&colorIndex=1">View All Color Results for ' + data.query + '</a></div>';
                        },
                        notFound: ''
                    }
                },
                {
                    name: 'collections',
                    display: 'label',
                    source: collections,
                    limit: 3,
                    templates: {
                        header: '<h5>Collections</h5>',
                        suggestion: function (collection) {
                            return '<div><a href="' + collection.path + '">' + collection.label + '</a></div>';
                        },
                        notFound: ''
                    }
                })
                .on("typeahead:selected", function (event, data, dataset) {
                    window.location.href = data.path || data.url;
                });
            }
        }
    }]);
})();

(function () {
    angular.module('AladdinCommercial').directive('autoCompleteSearchStylesFacet', ['$location', function ($location) {
        return {
            restrict: 'A',
            scope: {
                family: '@'
            },
            controller: 'PlpController',
            controllerAs: 'ctrl',
            link: function (scope, element, attrs, ctrl) {
                var family = attrs.family || 0;
                var subFamily = scope.$parent.selectedSubFamily !== null ? scope.$parent.selectedSubFamily.value : 0;

                var term = $location.search()['q'] || '';
                element.val(term);

                var styles = new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('normalizedStyleName', 'styleName', 'styleNumber', 'label'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    prefetch: {
                        url: '/api/products/suggestStyles?family=' + family + '&subFamily=' + subFamily,
                        cache: true,
                        cacheKey: 'ac-suggest-search-styles'
                    }
                });

                var collections = new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('normalizedCollection', 'collection'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    prefetch: {
                        url: '/api/products/suggestCollections?family=' + family + '&subFamily=' + subFamily,
                        cache: true,
                        cacheKey: 'ac-suggest-search-collections'
                    }
                });

                element.typeahead({
                    highlight: true,
                    hint: false
                },
                {
                    name: 'styles',
                    display: 'label',
                    source: styles,
                    limit: 4,
                    templates: {
                        header: '<h5>Styles</h5>',
                        suggestion: function (style) {
                            var stylePath = style.path;
                            return '<div><a data-name="' + style.styleName + '" href="' + stylePath + '">' + style.label + '</a></div>';
                        },
                        notFound: ''
                    }
                },
                {
                    name: 'collections',
                    display: 'label',
                    source: collections,
                    limit: 4,
                    templates: {
                        header: '<h5>Collections</h5>',
                        suggestion: function (collection) {
                            var div = document.createElement('div');
                            var span = document.createElement('span');
                            span.onclick = function (e) {
                                var collection = $(e.target).hasClass('tt-highlight') ? e.target.parentElement.dataset.name : e.target.dataset.name;
                                scope.$parent.predictiveSearchCollectionFacet(collection);
                            };

                            span.dataset.name = collection.collection;
                            span.innerText = collection.label;
                            div.appendChild(span);
                            return div;
                        },
                        notFound: ''
                    }
                });
            }
        }
    }]);
})();
(function() {

    'use strict';

    angular.module('AladdinCommercial').directive('closeNav', ["$compile", function($compile) {
            return {
                restrict: 'A',
                transclude: false,
                link: function(scope, $element, attrs) {
                    $element.bind('click', function() {
                        $element.removeClass('active');
                        $('.nav-first-level-link').removeClass('active');
                    });

                }
            };
        }]);
})();
(function() {

    'use strict';

    angular.module('AladdinCommercial').directive('closePrivacy', ["$compile", "localStorageService", function($compile, localStorageService) {
            return {
                restrict: 'A',
                link: function(scope, $element, attrs) {
                    var LOCAL_STORAGE_KEY = "AcceptedPrivacyPolicy";
                    if(!localStorageService.get(LOCAL_STORAGE_KEY)){
                        $element.closest('div.privacy-policy').css('display', 'block');   
                    }

                    $element.on('click', function() {
                        $element.closest('div.privacy-policy').css('display', 'none');
                    });

                    // Set the key to true once the message is viewed by the user
                    localStorageService.set(LOCAL_STORAGE_KEY, true);
                }
            };
        }]);
})();
(function () {
    'use strict';

    angular.module('AladdinCommercial')
        .directive('comparisonItem', ['CompareService', function (CompareService) {
            return {
                restrict: 'A',
                transclude: false,
                link: function (scope, $element, attr) {
                    scope.changeState = function(style) {
                        var productsToCompare = scope.$parent.productsToCompare.length;

                        if (productsToCompare < 3 || style.compareChecked === false) {
                            var added = false;

                            added = scope.$parent.tryAddToCompare(style);

                            if (!added) {
                                style.compareChecked = false;
                            } else {
                                CompareService.addToLocalStorage(style);
                            }
                        } else {
                            style.compareChecked = false;
                            scope.$parent.changeCompareDescription(true);
                        }

                        scope.safeApply();
                    };

                }
            };
        }]);
})();
(function () {
    'use strict';

    angular.module("AladdinCommercial").directive("dropContent", [function () {
        return {
            restrict: 'A',
            link: function (scope, $element, attrs) {
                $element.bind('click', function () {
                    if ($element.hasClass('drop-active')) {
                        $element.removeClass('drop-active');
                        $element.next('.drop-content').height(0).removeClass('drop-active');
                    }
                    else {
                        var $container = $element.closest('.drop-container');

                        $container.find('.drop-button').removeClass('drop-active');
                        $container.find('.drop-content').height(0).removeClass('drop-active');

                        $element.addClass('drop-active');
                        var $content = $element.next('.drop-content');
                        $content.height($content[0].scrollHeight).addClass('drop-active');
                    }
                });
            }
        }
    }])
})();
(function () {

    'use strict';

    angular.module('AladdinCommercial')
        .directive('hoverFix', ["$compile", function ($compile) {
            return {
                restrict: 'A',
                transclude: false,
                link: function (scope, element) {
                    var timeout = 0;
                    var dropdown = element.find('.dropdown-pane');

                    element.mouseleave(function (e) {
                        if (e.screenX === 0 && e.screenY === 0) {
                            // This is a fix for a Chrome bug, which incorrectly fires mouseleave/mouseout
                            // events when tapping with a trackpad on this dropdown.
                            return;
                        }
                        timeout = setTimeout(function () {
                            dropdown.foundation('close');
                        }, 250);
                    });

                    element.mouseenter(function () {
                        clearTimeout(timeout);
                    });
                }
            };
        }]);
})();
(function () {

    'use strict';

    angular.module('AladdinCommercial').directive('hideColumn', ['$window', 'CompareService', function ($window, CompareService) {
        return {
            scope: {
                compareStyleId: '@'
            },
            link: function (scope, $element, attrs) {
                var $table = $element.closest('table');
                var colNumber = $element.closest('tr').children().index($element.closest('td')) + 1;

                $element.bind('click', function () {
                    //// For now the code doesn't allow to remove the last column from the comparison. If needed we can add an else here and do something else.
                    if ($table.find('tr').first().find('td:visible').length > 3) {
                        $('td:nth-child(' + colNumber + ')', $table).hide();
                        $('.remove-column').hide();
                        CompareService.removeFromLocalStorage(scope.compareStyleId);

                        if (history.pushState) {
                            var urlParams = new URLSearchParams($window.location.search);
                            var newIds = [];
                            var newQuery = '';
                            var newurl = '';

                            angular.forEach(urlParams.getAll('productIds'), function(val, key) {
                                if (val != scope.compareStyleId) {
                                    newIds.push('productIds=' + val);
                                }
                            })

                            newQuery += '?' + newIds.join('&');
                            newurl = $window.location.protocol + "//" + $window.location.host + $window.location.pathname + newQuery;


                            $window.history.pushState({path:newurl},'',newurl);
                        }
                    }

                });
            }
        }
    }]);
})();
(function () {
    'use strict';

    angular.module("AladdinCommercial").directive("mobileMenu", [function () {
        return {
            restrict: 'A',
            link: function (scope, $element, attrs) {
                $('.cd-dropdown-trigger', $element).on('click', function (event) {
                    event.preventDefault();
                    var mobileSearchBar = $('.search-bar .mobile-search');
                    if (mobileSearchBar.hasClass('active')) {
                        mobileSearchBar.toggleClass('active');
                        $('.search-bar .search').toggleClass('mobile-active');
                    }
                    toggleNav();
                });

                //close meganavigation
                $('.cd-close', $element).on('click', function (event) {
                    event.preventDefault();
                    toggleNav();
                });

                function toggleNav() {
                    var navIsVisible = (!$('.cd-dropdown').hasClass('dropdown-is-active')) ? true : false;
                    $('.cd-dropdown').toggleClass('dropdown-is-active', navIsVisible);
                    $('.cd-dropdown-trigger').toggleClass('dropdown-is-active', navIsVisible);
                    $('#mobile-menu .cd-close').toggleClass('dropdown-is-active', navIsVisible);
                    $('body').toggleClass('mobile-nav-shown', navIsVisible);
                }
            }
        }
    }])
})();
(function () {
    'use strict';

    angular.module("AladdinCommercial").directive("mobileSearch", [function () {
        return {
            restrict: 'A',
            link: function (scope, $element, attrs) {
                $element.bind('click', function() {
                    if ($('.cd-dropdown').hasClass('dropdown-is-active')) {
                        $('.cd-dropdown').toggleClass('dropdown-is-active');
                        $('.cd-dropdown-trigger').toggleClass('dropdown-is-active');
                        $('#mobile-menu .cd-close').toggleClass('dropdown-is-active');
                        $('body').toggleClass('mobile-nav-shown');
                    }

                    $element.toggleClass('active');
                    $('.search-bar .search').toggleClass('mobile-active');

                    if ($element.hasClass('active'))
                    {
                        $('.search-bar .search input').focus();
                    }
                });
            }
        }
    }])
})();
(function() {

    'use strict';

    angular.module('AladdinCommercial').directive('navMenuMask', ["$compile", function($compile) {
            return {
                restrict: 'A',
                transclude: false,
                link: function(scope, $element, attrs) {
                    var mask = $('#mask-nav');

                    $element.bind('click', function() {
                        if ($element.hasClass('active')) {
                            $element.removeClass('active');
                            mask.removeClass('active');
                        }
                        else {
                            $('.nav-first-level-link').removeClass('active');
                            $element.addClass('active');
                            mask.addClass('active');
                        }
                    });

                }
            };
        }]);
})();
(function() {
    'use strict';

    angular.module('AladdinCommercial')
        .directive('owlCarousel', function() {
            return {
                restrict: 'E',
                transclude: false,
                link: function(scope, $element, attrs) {
                    scope.initCarousel = function(element) {
                        var parent$ = element.data('parent');
                        var defaultOptions = {
                            onInitialized: function(e) {
                                initCarouselWidth(e, parent$);
                            }
                        };
                        var customOptions = scope.$eval(element.data('options'));

                        for (var key in customOptions) {
                            defaultOptions[key] = customOptions[key];
                        }

                        if ($element.find('.item').length < 2) {
                            defaultOptions.loop = false;
                        }
                        // init Owl carousel
                        var owl = element.owlCarousel(defaultOptions);

                        if (element.data('expandable')) {
                            initExpandable(element, owl, defaultOptions);
                        }
                    };

                    if ('static' in attrs) {
                        scope.initCarousel($element);
                    }
                }
            };
        })
        .directive('owlCarouselItem', [function() {
            return {
                restrict: 'A',
                transclude: false,
                link: function(scope, element) {
                    // This waits for the last item on an ng-repeat before calling init for the carousel
                    if (scope.$last) {
                        scope.initCarousel(element.parent());
                    }
                }
            };
        }]);

    function initCarouselWidth(event, parent$) {
        var element = event.target;
        var $parent = $(element).closest(parent$);

        $(event.target).trigger('refresh.owl.carousel');

        setTimeout(function() {
            $parent.css('display', 'none').css('visibility', 'visible');
        }, 100);
    }

    function initExpandable(element, owlSlider, options) {
        var $button = element.next().find('.view-all');

        $button.click(function() {
            if ($button.data('opened')) {
                element.owlCarousel(options);
                $button.data('opened', false).html('View All');
            } else {
                owlSlider.trigger('destroy.owl.carousel');
                $button.data('opened', true).html('Collapse');
                element.css('display', 'block');
            }
        });
    }
})();
(function() {
    'use strict';

    angular.module('AladdinCommercial')
        .directive('printable', ["$compile", function($compile) {
            return {
                restrict: 'A',
                transclude: false,
                link: function(scope, $element, attr) {
                   $('body').addClass('printable');
                }
            };
        }]);
})();
/*global $ */
(function() {

    'use strict';

    angular.module('AladdinCommercial').directive('tabulator', ['$location', '$window', '$anchorScroll', function ($location, $window, $anchorScroll) {
        return {
            restrict: 'A',
            transclude: false,
            link: function(scope, $element) {

                var currentTab = $location.search().tab;
                var $activeTab = $element.find('.tab.active');
                var $activeContent = $element.find('#' + $activeTab.attr('data-tab'));
                var $tabToBeActive, $contentToBeActive;
                $anchorScroll.yOffset = 100;

                if (currentTab) {
                    $contentToBeActive = $element.find('#' + currentTab);
                    $tabToBeActive = $element.find('[data-tab=' + currentTab + ']');
                    changeActive();

                    var qsScroll = $location.search().scroll;
                    if (qsScroll === 'true' || qsScroll === '1') {
                        $location.hash(currentTab + '-tab');
                        $anchorScroll();
                    }
                }

                $element.find('.tab').click(function() {
                    var $mobileBreak = 1024;
                    var $this = $(this);
                    var $tabName = $this.attr('data-tab');

                    if (!$this.hasClass('active')) {
                        $activeTab = $element.find('.tab.active');
                        $activeContent = $element.find('#' + $activeTab.attr('data-tab'));
                        $tabToBeActive = $element.find('[data-tab=' + $tabName + ']');
                        $contentToBeActive = $element.find('#' + $tabName);

                        changeActive();
                        updateLocation($tabName);
                    } else {
                        if ($window.innerWidth > $mobileBreak) {
                            return;
                        }

                        $this.removeClass('active');
                        $element.find('#' + $this.attr('data-tab')).removeClass('active');
                    }
                });

                function updateLocation(tabName) {
                        $location.search('tab', tabName).replace();
                        scope.$apply();
                }

                function changeActive() {
                    $activeContent.removeClass('active');
                    $activeTab.removeClass('active');

                    $contentToBeActive.addClass('active');
                    $tabToBeActive.addClass('active');
                }
            }
        };
    }]);
})();
(function() {

    'use strict';

    angular.module('AladdinCommercial')
        .directive('videoModalClose', ["$compile", function($compile) {
            return {
                restrict: 'A',
                transclude: false,
                scope: {
                    videoid: '@'
                },
                link: function(scope, $element) {
                    $element.click(function() {
                        var video = Wistia.api(scope.videoid);
                        video.pause();
                        video.time(0);
                    });
                }
            };
        }]);
})();
(function() {

    'use strict';

    angular.module('AladdinCommercial')
        .directive('videoModal', ["$compile", function($compile) {
            return {
                restrict: 'A',
                transclude: false,
                scope: {
                    videoid: '@'
                },
                link: function(scope, $element) {
                    $element.click(function() {
                        var video = Wistia.api(scope.videoid);
                        video.play();
                    });
                }
            };
        }]);
})();
/*global _ */
(function() {
    'use strict';

    angular.module('AladdinCommercial').factory('CompareService', ['$http', 'localStorageService', function($http, localStorageService) {

        $http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
        var baseUrl = '/api/products/';
        var _stylesSubscribers = [];
        var compareLocalStorageKey = "compareStyles";

        // Public Functions
        var loadStyles = function(styles) {

            $http({
                method: 'POST',
                url: baseUrl + 'compareStyles',
                data: styles,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(handleStylesSuccess, handleStylesError);
        };

        var getLocalStorageKey = function() {
            return compareLocalStorageKey;
        };

        var addToLocalStorage = function(style) {
            var storedProductsToCompare = localStorageService.get(compareLocalStorageKey);
            if (storedProductsToCompare) {
                if (storedProductsToCompare.indexOf(style) === -1) {
                    storedProductsToCompare.push(style);
                    localStorageService.set(compareLocalStorageKey, storedProductsToCompare);
                }
            } else {
                localStorageService.set(compareLocalStorageKey, [style]);
            }
        };

        var removeFromLocalStorage = function(style) {
            var storedProductsToCompare = localStorageService.get(compareLocalStorageKey);
            if (storedProductsToCompare) {
                var index = storedProductsToCompare.indexOf(parseInt(style, 10));
                storedProductsToCompare.splice(index, 1);
                localStorageService.set(compareLocalStorageKey, storedProductsToCompare);
            }
        };

        // Private Functions
        function handleStylesSuccess(data) {
            var styles = angular.fromJson(data.data);

            updateStyleSubscribers(styles);
        }

        function handleStylesError(data) {
            // TODO Don't just console.error(data);
        }

        function subscribeStyles(subscriber) {
            _stylesSubscribers.push(subscriber);
        }

        function updateStyleSubscribers(styles) {
            _.forEach(_stylesSubscribers, function(callback) {
                callback(styles);
            });
        }

        return {
            loadStyles: loadStyles,
            subscribeStyles: subscribeStyles,
            addToLocalStorage: addToLocalStorage,
            removeFromLocalStorage: removeFromLocalStorage,
            getLocalStorageKey: getLocalStorageKey
        };
    }]);
})();
(function() {
    'use strict';

    angular.module('AladdinCommercial').factory('GoogleSearchService', ['$http', '$q', function($http, $q) {

        function googleSearch(query, start) {

            var url = 'https://www.googleapis.com/customsearch/v1?';
            url += 'key=AIzaSyCpvSspDOkr2F3ekbb5yC_w4baAxcLofmQ';
            url += '&cx=000976281450227790847:g1q65afenmk';
            url += '&q=' + query;

            if (start) {
                url += '&start=' + start;
            }

            var request = $http({
                method: 'GET',
                url: url
            });

            return request.then(handleSuccess, handleError);
        }

        function handleSuccess(response) {
            return response.data;
        }

        function handleError(response) {
            // The API response from the server should be returned in a
            // nomralized format. However, if the request was not handled by the
            // server (or what not handles properly - ex. server error), then we
            // may have to normalize it on our end, as best we can.
            if (!angular.isObject(response.data) || !response.data.message) {
                return ($q.reject("An unknown error occurred."));
            }

            // Otherwise, use expected error message.
            return ($q.reject(response.data.message));
        }

        return {
            googleSearch : googleSearch
        };

    }]);
})();
/*global angular, _ */
(function () {
    'use strict';

    angular.module('AladdinCommercial').factory('SearchService',  ['$http', 'ProductSettings', function ($http, ProductSettings) {

        $http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
        var baseUrl = '/api/products/';
        var _totalResults = 0;
        var _stylesSubscribers = [];
        var _facetsSubscribers = [];

        // Public Functions
        var loadStyles = function (productFamily, pageIndex, pageSize, facets, sorting, query, subFamily, forceColorIndex) {
            var subFamilyValue = null;

            if (subFamily) {
                if (Array.isArray(subFamily)) {
                    subFamilyValue = subFamily;
                } else {
                    subFamilyValue = [subFamily];
                }
            }

            var data = {
                family: productFamily,
                page: pageIndex,
                pageSize: pageSize,
                facets: facets,
                sorting: sorting,
                query: query,
                subFamily: subFamilyValue,
                forceColorIndex: forceColorIndex
            };

            $http({
                method: 'POST',
                url: baseUrl + 'styles',
                data: data,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(handleStylesSuccess, handleStylesError);
        };

        var loadProductDetail = function (styleId, colorId, successProductDetailCallback, failureProductDetailCallback) {
            $http({
                method: 'GET',
                url: ProductSettings.productsApiUrl + '/Detail?styleId=' + styleId + '&colorId=' + colorId,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then( function() { 
                if (successProductDetailCallback){
                    successProductDetailCallback.apply(null, arguments);
                } 
            }, function() {
                if (failureProductDetailCallback){
                    failureProductDetailCallback.apply(null, arguments);
                }
            });
        }

        // Private Functions
        function handleStylesSuccess(data) {
            var styles = angular.fromJson(data.data);

            _totalResults = styles.total;

            updateStyleSubscribersSuccess(styles.results);
        }

        function handleStylesError(data) {
            updateStyleSubscribersFailure(data);
        }

        function subscribeStyles(subscriberSuccess, subscriberFailure) {
            _stylesSubscribers.push({
                success: subscriberSuccess,
                failure: subscriberFailure
            });
        }

        function updateStyleSubscribersSuccess(styles) {
            _.forEach(_stylesSubscribers, function (item) {
                if (item.success) {
                    item.success(styles, _totalResults);
                }
            });
        }

        function updateStyleSubscribersFailure(data) {
            _.forEach(_stylesSubscribers, function (item) {
                if (item.failure) {
                    item.failure(data);
                }
            });
        }

        function loadFacets(productFamily) {
            $http.get(baseUrl + 'facets/' + productFamily)
                .then(handleFacetsSuccess, handleFacetsError);
        }

        function handleFacetsSuccess(data) {
            var facets = angular.fromJson(data.data);
            updateFacetsSubscribers(facets);
        }

        function handleFacetsError(data) {
            //console.error(data);
        }

        function subscribeFacets(subscriber) {
            _facetsSubscribers.push(subscriber);
        }

        function updateFacetsSubscribers(facets) {
            _.forEach(_facetsSubscribers, function (callback) {
                callback(facets);
            });
        }

        return {
            loadStyles: loadStyles,
            loadProductDetail: loadProductDetail,
            subscribeStyles: subscribeStyles,
            loadFacets: loadFacets,
            subscribeFacets: subscribeFacets
        };
    }]);
})();
(function() {

    'use strict';

    angular.module('AladdinCommercial').directive('plpScrollLoad', ["$document", "$timeout", "$window", function($document, $timeout, $window) {
        return {
            restrict: 'A',
            scope: {
                isLoading: '=isLoading',
                onLoad: '&onLoad'
            },
            link: function(scope, element, attrs) {
                var div = document.querySelector("html");

                $document.bind('scroll', function() {
                    if ($window.pageYOffset + div.offsetHeight >= (div.scrollHeight - 150) && !scope.isLoading) {
                        scope.$apply(scope.onLoad);
                    }
                });
            }
        };
    }]);
})();
(function() {
    'use strict';

    angular.module('AladdinCommercial').directive('resetPlpSearch', ["$compile", function($compile) {
        return {
            restrict: 'A',
            link: function(scope, $element) {
                $element.on('click', function(e) {
                    scope.$parent.clearQuery();

                    $element
                        .prev()
                        .find('input')
                        .typeahead('val', '');
                });
            }
        };
    }]);
})();

(function () {
    
        'use strict';
    
        angular.module('AladdinCommercial')
            .directive('searchPlp', ["$compile", function ($compile) {
                return {
                    restrict: 'A',
                    link: function (scope, $element) {
                        $element.keypress(function(e) {
                            var keycode = (e.keyCode ? e.keyCode : e.which);
                            if (keycode == '13') {
                                scope.$parent.changeQuery($element.val());
                                $element.blur();
                            }
                        });
                    }
                };
            }]);
    })();